import type { Invoice, InvoiceLine } from "@/types/camping";

/** Positionen nur im Entwurf – ausgestellte Rechnungen sind unveränderbar. */
export function canAddInvoiceLine(invoice: Invoice): boolean {
  return invoice.status === "draft";
}

/** Menge und Entfernen von Positionen nur im Rechnungsentwurf. */
export function canEditDraftInvoiceLines(invoice: Invoice): boolean {
  return invoice.status === "draft";
}

export function canDeleteInvoiceLine(invoice: Invoice, lines: InvoiceLine[]): boolean {
  return canEditDraftInvoiceLines(invoice) && lines.length > 1;
}
